<mat-card>

  <mat-card-header
  fxLayout="row wrap"
  fxLayoutAlign="space-between center"
  style="padding-bottom: 0px"
  *ngIf="editorEnable">

  <mat-card-title style="margin-top: 15px; margin-bottom: 15px;">{{ 'EditTemplateDisclaimer' | translate }}</mat-card-title>

</mat-card-header>

<mat-card-content>

  <ng-container *ngIf="editorEnable ; else notEnableTmpl">

    <app-editor-edit #TINY_EDITOR></app-editor-edit>

    <div mat-dialog-actions class="mat-dialog-actions button-template-cntr">

      <ct-button [configuration]="deleteButton"></ct-button>
      <ct-button [configuration]="saveAndArchiveButton"></ct-button>
      <ct-button [configuration]="saveButton"></ct-button>

    </div>

  </ng-container>

  <ng-template #notEnableTmpl>

    <div class="notEnable-cntr">
      <h2 style="font-weight: 700; color: red;">Attenzione</h2>
      <p>{{ 'EditTemplateNotEnable' | translate }} <br> <span style="font-weight: 600;">{{'EditTemplateNotEnableClick' | translate}}</span></p>

      <div mat-dialog-actions class="mat-dialog-actions" style="justify-self: end;">

        <ct-button [configuration]="submitButton"></ct-button>

      </div>

    </div>




  </ng-template>




</mat-card-content>

</mat-card>
